import { css } from '@emotion/core';
import { MediaQueries } from '../../../../../styles/Grid';
import { colorsPalette } from '../../../../../styles/colors';
import { typography, fontWeights } from '../../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../../utils/constants';

const PROGRESS_BAR_HEIGHT_SMALL_VIEWPORT = 103;
const PROGRESS_BAR_HEIGHT = 135;

export const geoNarrowingSpacer = css({
  height: `calc(100vh - (${
    NAV_MAX_HEIGHT_SMALL_VIEWPORT + PROGRESS_BAR_HEIGHT_SMALL_VIEWPORT
  }px))`,
  [MediaQueries.mdAndUp]: {
    height: `calc(100vh - (${NAV_MAX_HEIGHT + PROGRESS_BAR_HEIGHT}px))`,
  },
});

export const containerCss = css({
  height: '100%',
});

export const checkboxContainer = css({
  height: '40vh',
  overflowY: 'scroll',
  [MediaQueries.mdAndUp]: {
    height: 'calc(45vh - 100px)',
  },
  [MediaQueries.lgAndUp]: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export const geoRowWrapper = css({
  padding: '16px 20px',
  border: 'none',
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  '&:hover': {
    background: colorsPalette.grey10,
    '.locationQantity': {
      border: `1px solid ${colorsPalette.grey20}`,
    },
  },
});

export const geoRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const hoverableRow = css({
  cursor: 'pointer',
  '&:hover': {
    '.locationQantity': {
      color: colorsPalette.white,
      background: colorsPalette.teal,
    },
    '.moreInThisAreaBtn': {
      border: `1px solid ${colorsPalette.grey10}`,
      [MediaQueries.mdAndUp]: {
        '.moreInThisAreaLabel': {
          marginRight: 10,
          transition: 'margin 0.3 ease-in',
        },
        '.icon-chevron': {
          display: 'inline',
        },
      },
    },
  },
});

export const input = css({
  position: 'absolute',
  opacity: 0,
});

export const checkboxDecoration = css({
  position: 'absolute',
  left: -42,
  top: '50%',
  marginTop: -14,
  borderRadius: 2,
  width: 28,
  height: 28,
  border: `1px solid ${colorsPalette.grey20}`,
  textAlign: 'center',
  lineHeight: 1,
  transition: `border-color 0.3s, background-color 0.3s`,
  [MediaQueries.mdAndUp]: {
    left: -48,
  },
});

export const checkboxDecorationChecked = css({
  borderColor: colorsPalette.teal,
  backgroundColor: colorsPalette.teal,
});

export const checkboxDecorationDisabled = css({
  borderColor: colorsPalette.grey20,
  backgroundColor: colorsPalette.grey20,
});

export const checkboxIcon = css({
  color: colorsPalette.transparent,
  fontSize: 11,
});

export const checkboxIconChecked = css({
  color: colorsPalette.white,
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -6,
  marginLeft: -7,
});

export const parentLabel = css({
  display: 'inline-flex',
  position: 'relative',
  alignItems: 'center',
  flexDirection: 'row',
});

export const labelMargins = css({
  marginLeft: 35,
  [MediaQueries.mdAndUp]: {
    marginLeft: 44,
  },
});

export const nodeLabel = css(parentLabel, {
  cursor: 'pointer',
  '&:hover': {
    '.locationQantity': {
      color: colorsPalette.white,
      background: colorsPalette.teal,
    },
  },
});

export const locationName = css(typography.effra18, {
  marginRight: 8,
  lineHeight: 1.67,
});

export const locationQantity = css(typography.effra12Link, {
  fontWeight: fontWeights.medium,
  minWidth: 24,
  minHeight: 24,
  borderRadius: 2,
  lineHeight: 1.67,
  color: colorsPalette.teal,
  background: colorsPalette.grey10,
  border: `1px solid ${colorsPalette.grey10}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2px 5px',
});

export const locationQantityActive = css({
  color: colorsPalette.white,
  background: colorsPalette.teal,
});

export const moreInThisAreaBtn = css({
  cursor: 'pointer',
  display: 'inline-block',
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 2,
  background: colorsPalette.white,
  position: 'relative',
  padding: '2px 8px',
  width: 30,
  height: 30,
  [MediaQueries.mdAndUp]: {
    width: 'auto',
    height: 'auto',
  },

  '&:hover': {
    border: `1px solid ${colorsPalette.grey10}`,
    [MediaQueries.mdAndUp]: {
      '.moreInThisAreaLabel': {
        marginRight: 10,
        transition: 'margin 0.3 ease-in',
      },
      '.icon-chevron': {
        display: 'inline',
      },
    },
  },
});

export const moreInThisAreaBtnDisabled = css({
  pointer: 'not-allowed',
  '&:hover': {
    border: `1px solid ${colorsPalette.grey20}`,
    [MediaQueries.mdAndUp]: {
      '.moreInThisAreaLabel': {
        marginRight: 0,
      },
      '.icon-chevron': {
        display: 'none',
      },
    },
  },
});

export const moreInThisAreaLabel = css(typography.effra12Link, {
  fontWeight: fontWeights.medium,
  lineHeight: 1.67,
  display: 'none',
  [MediaQueries.mdAndUp]: {
    display: 'inline-block',
    marginRight: 0,
    transition: 'margin-right 0.5s ease-in',
  },
});

export const moreInChevronIcon = css({
  display: 'inline',
  fontSize: 11,
  [MediaQueries.mdAndUp]: {
    display: 'none',
  },
  '&:before': {
    position: 'absolute',
    transform: 'rotate(-85deg)',
    right: 13,
    top: '50%',
    bottom: '50%',
    [MediaQueries.mdAndUp]: {
      right: 10,
    },
  },
});

export const currentNode = css({
  padding: '0 20px 16px 16px',
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  [MediaQueries.mdAndUp]: {
    paddingBottom: 14,
  },
});

const currentNodeFont = css({
  ...typography.effra18,
  [MediaQueries.mdAndUp]: {
    ...typography.effra22,
  },
});

export const currentNodeLabel = css(currentNodeFont, {
  marginRight: 8,
});

export const backToParentWpp = css({
  marginTop: -16,
  marginBottom: 30,
});

export const backToParentBtn = css(typography.effra16, {
  border: 'none',
  position: 'relative',
  padding: 0,
  background: colorsPalette.transparent,
  cursor: 'pointer',
});

export const backIcon = css({
  marginRight: 20,
  marginTop: 2,
  '&:before': {
    position: 'absolute',
    transform: 'rotate(85deg)',
    left: 4,
    top: '50%',
    bottom: '50%',
  },
});

export const footNoteColumn = css({
  textAlign: 'center',
});

export const footNoteWrapper = css({
  display: 'flex',
  padding: '8px 16px',
  textAlign: 'center',
  border: `1px solid ${colorsPalette.grey10}`,
  background: colorsPalette.white,
  borderRadius: 4,
  position: 'fixed',
  bottom: 124,
  margin: '0 auto',
  display: 'inline-block',
  left: '50%',
  transform: 'translateX(-50%)',
  [MediaQueries.mdAndUp]: {
    bottom: 154,
  },
});
export const footNoteText = css(typography.effra14, {
  color: colorsPalette.teal,
});

export const geoNarrowingDescription = css({
  marginBottom: 40,
  [MediaQueries.mdAndUp]: {
    marginBottom: 48,
  },
  strong: {
    ...typography.effra12Link,
    margin: '0 8px',
    borderRadius: 2,
    color: colorsPalette.teal,
    background: colorsPalette.grey10,
    fontWeight: fontWeights.medium,
    lineHeight: 1.67,
    padding: '2px 5px',
  },
});

export const loader = css({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});
